import "babel-polyfill";
import * as React from 'react';
import { connect } from 'react-redux';
import Spinner from '../../common/components/spinner/spinner';
import * as actionTypes from '../../store/actionTypes';
import Translate from '../../common/functions/translate';
import { SelectButton } from 'primereact/selectbutton';
import AuthService from '../../services/authService';
import UserService from '../../services/userService';
import * as HelperFunctions from "../../common/functions/helperFunctions";
import * as Constants from '../../common/constants';
import Switch from '@material-ui/core/Switch';
import Growl from '../../common/components/alertMessage/growl';

interface IProps {
  onLangChange: any
}

interface IState {
  error: any,
  isLoading: boolean,
  currentLang: string,
  isActivePushNotifications: boolean
}

class SettingsComponent extends React.Component<IProps, IState> {

  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      currentLang: 'bg',
      isActivePushNotifications: false
    }
  }

  componentDidMount() {
    let lang = localStorage.getItem('lang');

    if (!lang) {
      localStorage.setItem('lang', 'bg');
    } else {
      this.props.onLangChange(lang);
    }

    this.userHasPushSubscription();

    this.setState({
      currentLang: localStorage.getItem('lang') + ''
    })
  }

  handleChangeLang = (lang) => {
    if (lang) {
      localStorage.setItem('lang', lang);
      this.props.onLangChange(lang);
      this.setState({
        currentLang: lang
      })
    }
    //window.location.reload();
  }

  userHasPushSubscription() {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistration().then((registration: any) => {
        if (registration) {
          registration.pushManager.getSubscription()
            .then(subscription => {
              if (subscription) {
                this.setState({
                  isActivePushNotifications: true
                });
              }
            });
        }
      });
    }
  }

  handleSwitchPushNotifications(subscribe: boolean) {
    this.setState({
      isLoading: true
    });

    if (subscribe) {
      this.subscribeForPushNotifications();
    } else {
      this.unsubscribeFromPushNotifications();
    }
  }

  subscribeForPushNotifications() {
    const pushIsSupported: boolean = 'serviceWorker' in navigator && 'PushManager' in window;
    if (!pushIsSupported)
      return;

    let applicationServerPublicKey = HelperFunctions.urlB64ToUint8Array(Constants.applicationServerPublicKey);

    navigator.serviceWorker.getRegistration()
      .then((registration: any) => {
        if (registration) {
          registration.pushManager.getSubscription()
            .then(subscription => {
              if (subscription) {
                // subscription present, no need to register subscription again
                this.growl.show({ severity: 'success', summary: Translate('You have already subscribed for Notifications.') });
                this.setState({
                  isLoading: false
                });
                return;
              }

              registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: applicationServerPublicKey
              })
                .then(subscription => {
                  this.userService.createPushSubscription(subscription)
                    .then((data: any) => {
                      if (data) {
                        this.setState({
                          isActivePushNotifications: true,
                          isLoading: false
                        });
                        this.growl.show({ severity: 'success', summary: Translate('You have successfully subscribed for Notifications.') });
                      }
                    })
                    .catch(error => this.catchErrorFailedToSubscribe(error));
                })
                .catch(error => this.catchErrorFailedToSubscribe(error));
            })
            .catch(error => this.catchErrorFailedToSubscribe(error));
        } else {
          this.catchErrorFailedToSubscribe({ message: '' })
        }
      });
  }

  catchErrorFailedToSubscribe = (error) => {
    this.setState({
      isLoading: false
    });
    this.growl.show({ severity: 'error', summary: Translate('Failed to subscribe for Push Notifications:') + error.message });
  }

  unsubscribeFromPushNotifications() {
    navigator.serviceWorker.getRegistration().then((registration: any) => {
      registration.pushManager.getSubscription()
        .then(subscription => {
          if (subscription) {
            subscription.unsubscribe()
              .then(() => {
                this.userService.discardPushSubscription(btoa(subscription.endpoint))
                  .then((res) => {
                    this.setState({
                      isActivePushNotifications: false,
                      isLoading: false
                    });
                    this.growl.show({ severity: 'success', summary: Translate('You have successfully unsubscribed from Notifications.') });
                  })
                  .catch(error => this.catchErrorFailedToUnsubscribe(error));
              })
              .catch(error => this.catchErrorFailedToUnsubscribe(error));
          }
        })
        .catch(error => this.catchErrorFailedToUnsubscribe(error));
    });
  }

  catchErrorFailedToUnsubscribe = (error) => {
    this.setState({
      isLoading: false
    });
    this.growl.show({ severity: 'error', summary: Translate('Failed to unsubscribe from Push Notifications:') + error.message });
  }

  public render() {

    const { isLoading, currentLang, isActivePushNotifications } = this.state;

    const langs = [
      { label: 'BG', value: 'bg' },
      { label: 'EN', value: 'en' }
    ];

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h2>{Translate('Settings')}</h2>

        <ul className="list-items">
          <li>
            <div className="item-info" style={{ flex: "60%" }}>
              <div className="item-name">
                {Translate("Language")}
              </div>
              <div className="item-desc">
                {currentLang == 'bg' ? Translate('Bulgarian') : Translate('English')}
              </div>
            </div>
            <div className="item-actions" style={{ flex: "40%", textAlign: 'right' }}>
              <SelectButton value={currentLang} options={langs} onChange={(e) => this.handleChangeLang(e.value)} />
            </div>
          </li>
          <li>
            <div className="item-info" style={{ flex: "60%" }}>
              <div className="item-name">
                {Translate("Notifications")}
              </div>
              <div className="item-desc">
                {!this.authService.isAuthenticated() ? Translate("You have to be logged in to activate Notifications.") : null}
              </div>
            </div>
            <div className="item-actions" style={{ flex: "40%", textAlign: "right" }}>
              <Switch
                checked={isActivePushNotifications}
                onChange={(e) => this.handleSwitchPushNotifications(e.target.checked)}
                color="primary"
                disabled={!this.authService.isAuthenticated()}
              />
            </div>
          </li>

          {/* <li>
            <div className="item-info">
              <div className="item-name">
                Item name
              </div>
              <div className="item-desc">
                Item desc
              </div>
            </div>
            <div className="item-actions">
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </li> */}

        </ul>

      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLangChange: (lang) => dispatch({ type: actionTypes.LANG_CHANGE, lang: lang })
  }
}

export default connect(null, mapDispatchToProps)(SettingsComponent);